<template>
  <div class="mainWarp">
    <div class="img-title">
      <img src="/iconImg/h_title_bg.png" />
      <span class="DataTitle">大用户近期用水量</span>
    </div>
    <div class="content">
      <div class="chart-container">
        <div class="left-chart">
          <div ref="waterUsePieChart" style="height: 100%; width: 100%;"></div>
        </div>
        <div class="middle-space">
          <img src="~@/assets/bigusers/largeScreen/waterUseMiddle.png" />
        </div>
        <div class="right-chart">
          <div ref="waterUseLineChart" style="height: 100%; width: 100%;"></div>
        </div>
      </div>
      <div class="top"></div>
      <div class="middle"></div>
      <div class="bottom"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: 'BottomWaterUse',
  data () {
    return {
      waterUseUrl: '/smart-water-major-users/major/users/user/user/water/count/year',
      data: [

      ],
      xShaft: [],
      thisYear: '',
      lastYear: '',
      thisYearData: [], //今年折线图数据
      lastYearData: [], //去年折线图数据

      pieData: [],
      pieText: '',
    }
  },
  mounted () {
    this.initChart();
  },
  methods: {
    async initChart () {
      try {
        await this.getWaterUseData();  // 等待数据获取并处理完成
        this.createWaterUseLineChart();
        this.createWaterUsePieChart();
      } catch (err) {
        console.error('初始化图表失败', err);
        // 可在此处做错误提示
      }
    },
    getWaterUseData () {
      // 返回一个 Promise
      return new Promise((resolve, reject) => {
        this.$http.get(this.waterUseUrl).then(res => {
          this.data = res.data;
          let data = res.data;
          this.thisYear = data.lastMonth[data.lastMonth.length - 1].selectTime;

          this.xShaft = [];         // 建议每次先清空，避免重复添加
          this.thisYearData = [];
          this.lastYearData = [];

          data.lastMonth.forEach(item => {
            const m = (item.selectTime || '').split('-')[1] || '';
            this.xShaft.push(Number(m) + '月');
            this.thisYearData.push({
              value: item.countWater,
              name: item.selectTime
            });
          });

          // 获取当前饼状图数据
          this.getPieData(data.lastMonth[data.lastMonth.length - 1], this.thisYear);

          this.lastYear = data.lastYearMonth[data.lastYearMonth.length - 1].selectTime;

          data.lastYearMonth.forEach(item => {
            this.lastYearData.push({
              value: item.countWater,
              name: item.selectTime
            });
          });

          // 所有数据处理完毕，resolve
          resolve();
        }).catch(err => {
          console.error('获取用水数据失败', err);
          reject(err);
        });
      });
    },
    getPieData (data, years) {
      const allData = [
        { name: '居民用水', value: data.waterTypeJm },
        { name: '非居民用水', value: data.waterTypeFjm },
        { name: '特种用水', value: data.waterTypeTz },
        { name: '其他', value: data.waterTypeQt }
      ];

      // 检查是否所有值都是0
      const allZero = allData.every(item => item.value === '0' || item.value === 0);

      // 如果所有值都是0，则不过滤；否则过滤掉值为0的项
      this.pieData = allZero ? allData : allData.filter(item => item.value !== '0' && item.value !== 0);
      console.log(this.pieData);
      this.pieText = `${years} 大用户用水量统计`
    },
    //初始化饼图
    createWaterUsePieChart () {
      const chartDom = this.$refs.waterUsePieChart;
      if (!chartDom) return; // 确保DOM元素存在

      // 如果已有图表实例，先销毁
      const existingChart = echarts.getInstanceByDom(chartDom);
      if (existingChart) {
        existingChart.dispose();
      }

      const myChart = echarts.init(chartDom);
      //创建Option对象
      let waterUsePieOption = {
        tooltip: {
          trigger: 'item',
        },
        graphic: [
          {
            type: 'text',
            left: '30%',
            bottom: 0,
            style: {
              text: this.pieText,
              fontSize: 12,
              fill: '#98BDFF'
            }
          }
        ],
        series: [
          {
            type: 'pie',
            radius: '60%',
            selectedMode: 'single',
            center: ['50%', '55%'],
            data: this.pieData,
            itemStyle: {
              color: function (params) {
                const colorList = [
                  new echarts.graphic.RadialGradient(0, 0, 1, [
                    { offset: 0, color: '#25A5FB' },
                    { offset: 1, color: '#0773F4' }
                  ]),
                  new echarts.graphic.RadialGradient(0, 0, 1, [
                    { offset: 0, color: '#610DD4' },
                    { offset: 1, color: '#840CF4' }
                  ]),
                  new echarts.graphic.RadialGradient(0, 0, 1, [
                    { offset: 0, color: '#09B7C7' },
                    { offset: 1, color: '#15D5B8' }
                  ]),
                  new echarts.graphic.RadialGradient(0, 0, 1, [
                    { offset: 0, color: '#F29C06' },
                    { offset: 1, color: '#EB970F' }
                  ])
                ];
                return colorList[params.dataIndex];
              },
            },
            // 标签线设置
            labelLine: {
              show: true,
              length: 10,  // 第一段线长度
              length2: 20, // 第二段线长度
              lineStyle: {
                width: 2,
                color: '#26b0ae'
              },
              z: 10  // 设置层级高于外边框
            },
            label: {
              formatter: function (params) {
                // 自定义富文本样式
                return [
                  `{name|${params.name}}\n`,  // 换行
                  `{value|${params.value}万(m³)}\n`,   // value 单独一行
                  `{percent|${params.percent}%}\n`,
                ].join('');
              },
              rich: {
                name: {
                  color: '#0cefed',  // 名称颜色
                  fontSize: 15,
                  fontWeight: '300',
                  lineHeight: '19',
                  align: 'left',  // 左对齐
                  padding: [0, 5, 0, 0]  // 调整间距
                },
                value: {
                  color: '#24a1e1',  // 数值颜色
                  fontSize: 12,
                  fontWeight: 'bold',
                  align: 'left',  // 左对齐
                },
                percent: {
                  color: 'rgba(255, 255, 255)',  // 数值颜色
                  fontSize: 12,
                  lineHeight: '19',
                  fontWeight: 'bold',
                  align: 'left',  // 左对齐
                }
              }
            },
            emphasis: {
              itemStyle: {
                borderColor: 'transparent',  // 完全透明
                borderWidth: 5
              }
            }
          },
          {
            name: '外边框',
            type: 'pie',
            clockWise: false,
            silent: true,
            labelLine: { show: false },
            radius: '50%',
            data: [{
              value: 0,
              itemStyle: {
                color: 'rgba(5, 13, 43, 0.5)',
                shadowOffsetX: 0,      // 阴影水平偏移，正值向右
                shadowOffsetY: 0,      // 阴影垂直偏移，正值向下
                shadowColor: 'rgba(28, 118, 174, 0.8)',
                shadowBlur: 30,
              }
            }],
            z: 1  // 设置层级低于饼图
          },
        ]
      }
      myChart.setOption(waterUsePieOption);
      // 响应式调整
      window.addEventListener('resize', () => {
        myChart.resize();
      });
    },
    //初始化折线图
    createWaterUseLineChart () {
      const chartDom = this.$refs.waterUseLineChart;
      const myChart = echarts.init(chartDom);
      //创建Option对象
      let waterUseLineOption = {
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: this.xShaft,
          axisLabel: {
            color: '#98BDFF'
          },
          axisLine: {
            lineStyle: {
              color: '#1519CA'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(152, 189, 255, 0.3)'
            }
          }
        },
        yAxis: {
          type: 'value',
          // max: 80,  // 最大值
          splitNumber: 8,
          axisLabel: {
            formatter: '{value} 万', // 在数值后添加"万"字
            color: '#98BDFF'
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#1519CA'
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: 'rgba(152, 189, 255, 0.3)'
            }
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: `{b} <br/>总用水量: {c}万m³`,
          backgroundColor: "rgba(42, 128, 226, 0.8)",
          textStyle: { // 悬浮框文字样式
            color: '#fff'
          }
        },
        legend: {
          orient: 'vertical', // 图例的排列方向
          x: 'right', // 图例在右侧
          y: 'center', // 图例在垂直居中
          align: 'left',
          padding: [0, 0, 0, 0], // 图例的内边距
          data: ['去年', '今年'],
          textStyle: {
            color: '#98BDFF'
          },
        },
        grid: {
          top: 15,
          bottom: 30
        },
        graphic: [
          {
            type: 'text',
            top: 0,
            left: 60,
            style: {
              text: 'm³',
              fill: '#98BDFF',
              fontSize: 12
            }
          },
          {
            type: 'text',
            bottom: 20,
            right: 20,
            style: {
              text: '月份',
              fill: '#98BDFF',
              fontSize: 12
            }
          }
        ],
        series: [
          {
            name: '去年',
            data: this.lastYearData,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              type: 'dotted',
              color: '#D8B513',
            },
            itemStyle: {
              color: '#e49b11',
              borderColor: 'white',
            },
          },
          {
            name: '今年',
            data: this.thisYearData,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            lineStyle: {
              color: '#7391ca'
            },
            itemStyle: {
              color: '#0314ff',
              borderColor: 'white',
            },
          }
        ]
      };
      myChart.setOption(waterUseLineOption);

      // 监听点击事件
      myChart.on('click', (params) => {
        console.log('点击事件参数:', params);
        // 判断是否点击了数据节点（而不是空白区域）
        if (params.componentType === 'series' && params.seriesType === 'line') {
          for (let key in this.data) {
            this.data[key].forEach(item => {
              if (item.selectTime == params.name) {
                this.getPieData(item, item.selectTime);
              }
            })
          }
          this.createWaterUsePieChart();
        }
      });
      // 响应式调整
      window.addEventListener('resize', () => {
        myChart.resize();
      });
    }
  }
}
</script>

<style lang="less" scoped>
.mainWarp {
  height: 220px;
  width: 1072.7px;
  position: relative;

  .content {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .chart-container {
    position: absolute;
    top: 25px;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    display: flex;
    padding: 0 24px;
    box-sizing: border-box;
  }

  .left-chart {
    width: 35%;
    height: 220px;
    // background: rgba(0, 46, 113, 0.3);
    // border: 1px solid rgba(0, 150, 255, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00ebee;
  }

  .middle-space {
    width: 2%;
    height: 220px;
    display: flex;
    justify-content: center;
    /* 水平居中 */
    align-items: center;

    /* 垂直居中 */
  }

  .right-chart {
    width: 63%;
    height: 240px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #00ebee;
  }

  .top {
    flex: 0 0 60px;
    background: url(~@/assets/bigusers/largeScreen/topBox2.png) no-repeat;
    background-size: 100% 100%;
  }

  .middle {
    flex: 0 0 70%;
    background: url(~@/assets/bigusers/largeScreen/middleBox2.png) repeat;
    background-size: 100% auto;
  }

  .bottom {
    flex: 0 0 60px;
    background: url(~@/assets/bigusers/largeScreen/bottomBox2.png) no-repeat;
    background-size: 100% 100%;
  }

  .img-title {
    position: absolute;
    top: -23px;
    left: calc(81% - 2px);
    transform: translateX(-50%);
    text-align: center;
    font-family: MicrosoftYaHeiSemibold;
    font-size: 18px;
    color: #00ebee;
    font-weight: 600;
    line-height: 30px;
    z-index: 1;

    .DataTitle {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }

    img {
      width: 264px;
      height: 35px;
    }
  }
}
</style>